import React, { Component } from 'react';
import { Link } from "react-router";
import { database, auth, storage } from '../firebase';
import '../css/PostForm.css';
import PropTypes from 'prop-types';
const { isDev } = require("../project.json")
var randomstring = require("randomstring");

class PostForm extends Component {
  constructor(state) {
    super(state);
    this.data = state.data;
    this.state = {
      newPostTitle: "",
      newPostContent: "",
      newPostDate: "",
      fileLink: null,
      tags: [],
      file: null,
       
      kaydedildi: false,
      data: []
    }

    //this.overlaySaveDraft = this.overlaySaveDraft.bind(this);
    this.saveDraft = this.saveDraft.bind(this);
    this.writeDraft = this.writeDraft.bind(this);
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      database.ref("drafts").child(user.uid+"/"+window.location.pathname.slice(8)).get().then((snap) => {
        if (!snap.exists()) return window.location.pathname = "/404";

        this.setState({data: snap.val()})
        this.setState({
          newPostTitle: snap.val().draftTitle,
          newPostContent: snap.val().draftContent,
          fileLink: snap.val().draftImage,
          tags: snap.val().draftTags || []
        })
      })
    })
  }

  onFileUpload = async () => {
    var asdf = "";
    var file = this.state.file;

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert("Dosya boyutu maksimum 5MB olmalıdır.");
        return; // Exit the function if the file is too large
      }
      if (!file.type.startsWith("image/") || file.type === "image/gif") {
        alert("Desteklenmeyen bir dosya türü seçildi.");
        return; // Exit the function if the file type is not supported
      }

      document.getElementById("overlay").style.display = "block";
      document.getElementById("overlay-img").style.display = "block";
      const storages = storage.ref("draft-photos").child(window.location.pathname.slice(8));
      await storages.put(file)
      await storages.getDownloadURL().then((url) => {
        asdf = url;
        database.ref("drafts").child(auth.currentUser.uid+"/"+window.location.pathname.slice(8)).update({
          draftImage: url
        })
      })
    }
    this.setState({ fileLink: asdf })

    window.location.pathname = "/taslaklar";
  };

  onFileUploadEnd = async (id) => {
    var asdf = "";
    var file = this.state.file;

    if (file) {
      document.getElementById("overlay").style.display = "block";
      document.getElementById("overlay-img").style.display = "block";
      const storages = storage.ref("post-photos").child(window.location.pathname.slice(8));
      await storages.put(file)
      await storages.getDownloadURL().then((url) => {
        asdf = url;
        database.ref("posts").child(id).update({
          postImage: url
        })
        database.ref("drafts").child(auth.currentUser.uid+"/"+window.location.pathname.slice(8)).update({
          draftImage: url
        })
      })
    }
    this.setState({ fileLink: asdf })

    window.location.pathname = "/taslaklar";
  };

  //overlaySaveDraft() {
  //  console.log("saved")
  //  database.ref("drafts").child(auth.currentUser.uid+"/"+window.location.pathname.slice(8)).set({
  //    draftTitle: this.state.newPostTitle,
  //    draftContent: this.state.newPostContent,
  //    draftDate: 0,
  //    draftImage: this.state.fileLink,
  //    draftAuthor: auth.currentUser.uid,
  //    draftTags: this.state.tags
  //  })
  //}

  async saveDraft() {
    await this.setState({ kaydedildi: true });
    this.onFileUpload();

    var data = {
      newDraftTitle: this.state.newPostTitle,
      newDraftContent: this.state.newPostContent,
      newDraftImage: this.state.fileLink,
      newDraftTags: this.state.tags
    }
    database.ref("drafts").child(auth.currentUser.uid+"/"+window.location.pathname.slice(8)).update({
      draftTitle: data.newDraftTitle || null,
      draftContent: data.newDraftContent || null,
      draftImage: data.newDraftImage || null,
      draftTags: data.newDraftTags || null
    })
  }

  async writeDraft() {
    var newPostId = randomstring.generate(20);

    var data = {
      newDraftTitle: this.state.newPostTitle,
      newDraftContent: this.state.newPostContent,
      newDraftImage: this.state.fileLink,
      newDraftTags: this.state.tags
    }
    await database.ref("drafts").child(auth.currentUser.uid+"/"+window.location.pathname.slice(8)).update({
      draftTitle: data.newDraftTitle || null,
      draftContent: data.newDraftContent || null,
      draftImage: data.newDraftImage || null,
      draftTags: data.newDraftTags || null,
      draftShared: true
    })
    
    if (this.state.newPostTitle == "") return alert('Başlık boş olamaz!')
    else if (this.state.newPostContent == "") return alert('Yazı boş olamaz!')
    else {
      await database.ref().child('posts').child(newPostId).set({
        postTitle: this.state.newPostTitle || null,
        postContent: this.state.newPostContent || null,
        postDate: Date.now(),
        postImage: this.state.fileLink || null,
        postAuthor: auth.currentUser.uid || null,
        postTags: this.state.tags || null,
      });

      this.onFileUploadEnd(newPostId);
    }
  }
      
  removeTag = (i) => {
    const newTags = [ ...this.state.tags ];
    newTags.splice(i, 1);
    this.setState({ tags: newTags });
  }

  inputKeyDown = (e) => {
    const val = e.target.value;
    if (e.key === 'Enter' && val) {
      if (this.state.tags.find(tag => tag.toLowerCase() === val.toLowerCase())) {
        return;
      }
      this.setState({ tags: [...this.state.tags, val]});
      this.tagInput.value = null;
    } else if (e.key === 'Backspace' && !val) {
      this.removeTag(this.state.tags.length - 1);
    }
  }

  render() {
    const { tags } = this.state;
    //function calcHeight(value) {
    //  let numberOfLineBreaks = (value.match(/\n/g) || []).length;
    //  let newHeight = 22 + numberOfLineBreaks * 22 + 12 + 2;
    //  return newHeight;
    //}
  
    //let textarea = document.querySelector("textarea");
    //if (textarea) textarea.click();
    //if (textarea) textarea.addEventListener("click", () => {
    //  textarea.style.height = calcHeight(textarea.value) + "px";
    //});

    //setInterval(() => {this.overlaySaveDraft()}, 5000)
    //window.addEventListener("keyup", this.overlaySaveDraft)
    window.onbeforeunload = () => {
      if (isDev == false && this.state.kaydedildi == false) return "";
    };

    return (
    <div className="postform-div"><div style={{textAlign: "center"}}>
      <div className="overlay" id="overlay"></div>
      <img src="/loading.svg" className="overlay-img" id="overlay-img"/>
      <Link to="/taslaklar" style={this.state.data.draftShared == true ? {display: "block"} : {display: "none"}}>
        <img src="/back.png" className="back"/>
      </Link>
      <h4 className="title">{this.state.data.draftShared == true ? "Yayınlanmış Taslak" : "Taslak"}</h4>
      <label className="resim2" htmlFor={this.state.data.draftShared == true ? "" : "imeyç"} style={this.state.data.draftShared == true ? {cursor: "unset"} : {cursor: "pointer"}}>
        <img src={this.state.fileLink||"/default.jpg"} id="draft_photo" style={this.state.data.draftShared == true ? {borderRadius: "10px"} : {}}/>
        <div style={this.state.data.draftShared == true ? {display: "none"} : {display: "block"}} className="upload">Yazı Resmi Yükle</div></label>
      <input placeholder="Yazı Başlığı" className="baslik" maxLength="24" value={this.state.newPostTitle} onChange={event => this.setState({newPostTitle: event.target.value})} disabled={this.state.data.draftShared == true ? "disabled" : ""}/>
      <div>
        <textarea placeholder="Yazı İçeriği" id="area" className="icerik" value={this.state.newPostContent} onChange={event => {this.setState({newPostContent: event.target.value})}} disabled={this.state.data.draftShared == true ? "disabled" : ""}/>
      </div>
      <input id="imeyç" className="resim" type="file" accept="image/*" onChange={e => {document.getElementById('draft_photo').src = window.URL.createObjectURL(e.target.files[0])
      this.setState({file: e.target.files[0]})}}/>
      <br/>

      <div className="input-tag" style={this.state.data.draftShared == true ? {background: "#F57029", color: "#F57029"} : {}}>
       <ul className="input-tag__tags">
         {tags.map((tag, i) => (
           <li key={tag}>
             {tag}
             <button type="button" onClick={() => { this.removeTag(i); }} style={this.state.data.draftShared == true ? {display: "none"} : {}}>+</button>
           </li>
         ))}
         <li className="input-tag__tags__input" style={this.state.data.draftShared == true ? {display: "none"} : {}}>
           <input type="text" placeholder={this.state.data.draftShared == true ? "" : "En az 1 etiket gir."} onKeyDown={this.inputKeyDown} ref={c => { this.tagInput = c; }} />
         </li>
       </ul>

       <style>{`
           html {
             background: #f57029;
           }

           .main {
             background: #f57029;
           }

           .overlay {
             top: 0;
             left: 0;
             background: #fff;
             position: fixed;
             width: 100%;
             height: 100%;
             opacity: 0.7;
             z-index: 888;
             display: none;
           }

           .overlay-img {
             top: 50%;
             left: 50%;
             width: 150px;
             height: 150px;
             position: fixed;
             margin-top: -75px;
             margin-left: -75px;
             z-index: 899;
             display: none;
           }

           .input-tag {
             background: white;
             border-radius: 10px;
             display: flex;
             flex-wrap: wrap;
             padding: 7px 7px 2px;
             max-width: 486px;
             margin: 10px auto;
             margin-bottom: 30px;
           }
           
           .input-tag input {
             border: none;
             width: 100%;
             color: #000;
             text-align: left;
             font-size: 15px;
             background: inherit;
           }
           
           .input-tag__tags {
             display: inline-flex;
             flex-wrap: wrap;
             margin: 0;
             padding: 0;
             width: 100%;
           }
           
           .input-tag__tags li {
             align-items: center;
             background: #2f2d33;
             border-radius: 6px;
             color: white;
             display: flex;
             font-weight: 300;
             list-style: none;
             margin-bottom: 5px;
             margin-right: 5px;
             padding: 5px 10px;
           }
           
           .input-tag__tags li button {
             align-items: center;
             appearance: none;
             background: #333333;
             border: none;
             border-radius: 50%;
             color: white;
             display: inline-flex;
             font-size: 12px;
             height: 15px;
             justify-content: center;
             line-height: 0;
             margin-left: 8px;
             padding: 0;
             transform: rotate(45deg);
             width: 15px;
           }
           
           .input-tag__tags li.input-tag__tags__input {
             background: none;
             flex-grow: 1;
             padding: 0;
           }

           @media (max-width: 623px) {
             .input-tag {
              border-radius: 0;
             }
           }
       `}</style>
      </div>

      {this.state.data.draftShared == true ? "" : <div className="buttons">
        <button onClick={this.saveDraft} className="saveBtn">Kaydet</button>
        <button onClick={this.writeDraft} className="publishBtn">Yayınla!</button>
      </div>}
      </div>
    </div>
  )}
}

export default PostForm;